export const getErrorMessage = (error, defaultMessage = 'Something went wrong') => {
  const errorData = error?.response?.data;
  return errorData?.errorMessage || errorData?.message || error?.message || defaultMessage;
};

